<template>
<div>
  <products-list-add-new
      :is-add-new-product-sidebar-active.sync="isAddNewProductSidebarActive"
      :role-options="roleOptions"
      @refetch-data="refetchData"
    />
  <b-card
  no-body
  class="mb-50"
  >
  <div class="m-1">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Entries</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="Search by Product Phone or Membership Number..."
            />
            <b-button
                variant="primary"
                @click="isAddNewProductSidebarActive = true"
              >
                <span class="text-nowrap">Add Product</span>
              </b-button>
          </div>
        </b-col>
      </b-row>

    </div>
  </b-card>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <b-table
      ref="refProductListTable"
      :items="fetchProducts"
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :busy.sync="isBusy"
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >
    <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner
          label="Loading..."
          class="align-middle">
          </b-spinner>
          <strong class=" ml-2">Fetching...</strong>
        </div>
      </template>
      <template #cell(name)="data">
        <span
        class="text-nowrap">
          {{ data.item.name }}
        </span>
      </template>

      <!-- Column: Issued Date -->
      <template #cell(description)="data">
        <span class="text-nowrap">
          {{ data.item.description }}
        </span>
      </template>
      <!-- Column: Issued Date -->
      <template #cell(priority)="data">
        <span class="text-nowrap">
          <b-badge
          :id="`outbox-row-${data.item.id}-product-priority`"
          variant="info"
          >
          {{ data.item.priority }}
          </b-badge>
        </span>
      </template>
      <template #cell(status)="data">
        <b-badge
          :id="`product-row-${data.item.id}-status`"
          :variant="`light-${resolveProductStatusVariantAndIcon(data.item.status).variant}`"
        >
          <feather-icon
            :icon="resolveProductStatusVariantAndIcon(data.item.status).icon"
          />
          {{ data.item.status }}
        </b-badge>
      </template>
        <template #cell(num_inquiries)="data">
        <b-badge
          :id="`product-row-${data.item.id}-num_inquiries`"
          variant="light-secondary"
          pill
        >
          {{ data.item.num_inquiries }}
        </b-badge>
      </template>
      <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!-- <b-dropdown-item :to="{ name: 'apps-products-view', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item> -->

            <b-dropdown-item :to="{ name: 'apps-products-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Manage Product</span>
            </b-dropdown-item>
            <!-- <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalProducts"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>
</div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BBadge,
  BPagination, BDropdown, BDropdownItem, BButton, BSpinner,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import useProductsList from './useProductsList'

import productsStoreModule from '../productsStoreModule'
import ProductsListAddNew from './ProductsListAddNew.vue'

export default {
  components: {
    ProductsListAddNew,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BButton,
    BSpinner,
    BBadge,
    vSelect,
  },
  setup() {
    const PRODUCTS_APP_STORE_MODULE_NAME = 'products'

    // Register module
    if (!store.hasModule(PRODUCTS_APP_STORE_MODULE_NAME)) store.registerModule(PRODUCTS_APP_STORE_MODULE_NAME, productsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PRODUCTS_APP_STORE_MODULE_NAME)) store.unregisterModule(PRODUCTS_APP_STORE_MODULE_NAME)
    })

    const isAddNewProductSidebarActive = ref(false)
    const roleOptions = [
      { label: 'Group Leader', value: 'ADMIN' },
      { label: 'Group Member', value: 'STAFF' },
    ]

    const {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductListTable,

      statusFilter,
      isBusy,

      refetchData,

      resolveProductStatusVariantAndIcon,
      resolveProductAvatarVariant,
    } = useProductsList()

    return {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductListTable,
      isBusy,

      statusFilter,
      roleOptions,

      refetchData,
      isAddNewProductSidebarActive,
      avatarText,
      resolveProductStatusVariantAndIcon,
      resolveProductAvatarVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.product-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
